export default __webpack_public_path__ + "static/media/ENGLISH_BOOKS_READING.fc393f10.svg";